export const iconButtonSx = {
    backgroundColor: '#fff',
    border: '1px solid #bfbfbf',
    borderRadius: '2px',
    p: '12px',
    '&:hover': {
        backgroundColor: '#fff',
    },
    '&:disabled': {
        backgroundColor: '#F5F5F5',
        '& svg path': {
            fill: '#BFBFBF',
        },
    },
    '& svg': {
        width: '18px',
        height: '18px',
        color: '#262626',
    },
};

export const menuPaperSx = {
    mt: '5px',
    borderRadius: '4px',
    p: 0,
    border: '1px solid #D9D9D9',
    boxShadow: '0px 4px 6px -2px #10182808, 0px 12px 16px -4px #10182814',
};

export const menuItemSx = {
    minHeight: 'auto',
    fontFamily: 'Rubik',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '18px',
    p: '8.5px 20px',
    background: '#fff',
    color: '#565656',
    '&:hover': {
        background: '#F5F5F5',
    },
};
